import $api from "http";

class HomepageContentService {
  // Получить активный контент главной страницы
  static async getActiveContent() {
    try {
      const response = await $api.get('/api/homepage-content/active');
      return response.data;
    } catch (error) {
      // Возвращаем пустой объект вместо ошибки, чтобы не ломать главную страницу
      return {
        content: '',
        title: 'Нет активного контента'
      };
    }
  }

  // Получить все записи контента (для админки)
  static async getAllContent() {
    try {
      const response = await $api.get('/api/homepage-content');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Создать новый контент
  static async createContent(data) {
    try {
      const response = await $api.post('/api/homepage-content', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Обновить существующий контент
  static async updateContent(id, data) {
    try {
      const response = await $api.put(`/api/homepage-content/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Удалить контент
  static async deleteContent(id) {
    try {
      const response = await $api.delete(`/api/homepage-content/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Активировать контент
  static async activateContent(id) {
    try {
      const response = await $api.patch(`/api/homepage-content/${id}/activate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default HomepageContentService;
